<section class="centered-fullwidth pb-16 pt-2">
  <!-- Sorting Filter -->
  <div class="mb-6">
    <app-filter-select [options]="filterSelectionOptions" filterName="filter_selection" />
  </div>

  <!-- Kitchen Models Grid -->
  <div class="grid h-auto grid-cols-1 gap-y-5 desk:grid-cols-2 desk:gap-x-3">
    @for (kitchen of kitchens(); track kitchen.id) {
      <div (viewportObserver)="onReviewViewportEnter($event, kitchen.id)">
        <app-kitchen-model-card [kitchen]="kitchen" [initialVariantId]="preselectedSwatches()[kitchen.id]" />
      </div>
    }
  </div>
</section>
